import { msg, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { TFPageContent } from '@tf/shared';
import { Center, Flex, Icon, TFCard, TFText } from '@tf/ui';
import type React from 'react';

import { CompanyLogo } from '@/components/shared';

import { usePageTitle } from '../../usePageTitle';

export const CaseRequestSuccessRoute: React.FC = () => {
	const { _ } = useLingui();

	usePageTitle(_(msg({ id: 'caseRequestSentPage.title', message: 'Request submitted' })));

	return (
		<TFPageContent maw="40rem" m="0">
			<Center mb="16px">
				<CompanyLogo />
			</Center>

			<TFCard innerPadding="2rem">
				<Flex justify="center">
					<Icon.IconCircleCheck color="#51C564" size="40px" />
				</Flex>
				<TFText ta="center" size="26px" fw="600">
					<Trans id="caseRequestSentPage.title">Request submitted</Trans>
				</TFText>
				<TFText mt="0.5rem" ta="center">
					<Trans id="caseRequestSentPage.message">
						Thank you for submitting request, it has been sent successfully.
					</Trans>
				</TFText>
			</TFCard>
		</TFPageContent>
	);
};
